import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { Subscription } from 'rxjs';
import { NgTemplateOutlet } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-fan-reasons',
  templateUrl: './fan-reasons.component.html',
  styleUrls: ['./fan-reasons.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    TranslocoModule,
    NgTemplateOutlet,
    MatCard,
    MatCardContent,
    MatIcon,
  ],
})
export class FanReasonsComponent implements OnInit, OnDestroy {
  private translocoService = inject(TranslocoService);

  public reasons: Array<{title: string, description: string}>;

  private translationSub: Subscription;

  ngOnInit() {
    this.translationSub = this.translocoService.selectTranslateObject('fanReasons')
      .subscribe((translations) => {
        this.reasons = [
          {
            title: translations.everyOneDeserveASecondChance,
            description: translations.mishapResale + '<span class="fw-700">' + translations.free + '</span>' + translations.ticketToOther,
          },
          {
            title: translations.refurbishedTickets,
            description: translations.parternship + '<span class="fw-700">' + translations.newTicket + '</span>' + translations.buyerName,
          },
          {
            title: translations.speculationImpossible,
            description: translations.ticketKeptToRealFan,
          },
        ];
      });
  }

  ngOnDestroy(): void {
    this.translationSub?.unsubscribe();
  }
}
